import { get } from "lodash";

const getFreezeEventsHasMore = state => {
  const id = get(state, "factoringClient.id", "");
  const next = get(state, `factoringClient.freezeEvents.${id}.next`);
  const loading = get(state, "factoringClient.freezeEventsLoading", false);
  return Boolean(next && !loading);
};

export default getFreezeEventsHasMore;
